function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  transform: "translate(-1067 -4665) translate(0 4345) translate(340 130) translate(0 178)"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M0 10.488V4.5C0 2.015 2.015 0 4.5 0h11.071c2.486 0 4.5 2.015 4.5 4.5v5.988c0 2.485-2.014 4.5-4.5 4.5H9.598c-.402 0-.787.161-1.069.448L5.402 19.01c-.564.574-1.54.174-1.54-.631v-3.398C1.486 14.858 0 12.893 0 10.488zm7.247 3.685c.62-.63 1.467-.985 2.351-.985h5.973c1.492 0 2.7-1.209 2.7-2.7V4.5c0-1.491-1.208-2.7-2.7-2.7H4.5c-1.491 0-2.7 1.209-2.7 2.7v5.988c0 1.491.809 2.7 2.3 2.7h.661c.497 0 .9.403.9.9v2.095l1.586-2.01z",
  transform: "translate(680) translate(47 12) translate(14 15)"
}), React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M22.9 6.8c2.485 0 4.5 2.015 4.5 4.5v5.588c0 2.405-1.487 4.37-3.861 4.494v3.398c0 .805-.977 1.205-1.541.631l-3.127-3.575c-.282-.287-.667-.448-1.07-.448H14.23c-2.486 0-4.5-2.015-4.5-4.5l-.002-3.521c.342-.118.703-.179 1.071-.179h.73v3.7c0 1.434 1.118 2.607 2.53 2.695l.17.005h3.574c.884 0 1.731.355 2.351.985l1.586 2.01v-2.095c0-.497.403-.9.9-.9h.661c1.491 0 2.3-1.209 2.3-2.7V11.3c0-1.491-1.209-2.7-2.7-2.7l-4.629-.001V6.8z",
  transform: "translate(680) translate(47 12) translate(14 15)"
}), React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8,
  d: "M5.6 5.56L14.4 5.56M5.6 8.76L12 8.76",
  transform: "translate(680) translate(47 12) translate(14 15)"
})))))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/comment.e586ee57.svg";
export { SvgComponent as ReactComponent };